import React from 'react';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import useSnack from 'hooks/useSnack';
import { makeStyles } from '@material-ui/core/styles';
import { MESSAGE_VARIABLES } from 'constant/notifications';

const useStyles = makeStyles((theme) => ({
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  }
}));

const Variable = ({ label, value }) => {
  const snack = useSnack();
  const classes = useStyles();
  return  (
    <CopyToClipboard text={value} onCopy={() => snack.success('Copied to clipboard.')}>
      <Chip size={'small'} classes={{ root: classes.chip }} label={label} clickable />
    </CopyToClipboard>
  );
}

const Variables = ({ }) => {
  return (
    <Box>
      <Typography variant="subtitle1">Message Variables</Typography>
      <Typography gutterBottom variant="body2">Click on the variable to copy and paste in your message. Note, Some variables are scoped to specific triggers.</Typography>
      <Box>
        {Object.keys(MESSAGE_VARIABLES).map(key => (
          <Variable label={MESSAGE_VARIABLES[key]} value={key} key={key} />
        ))}
      </Box>
    </Box>
  )
};

export default Variables;